export default {
  title: 'Contactgegevens',
  form: {
    customer_first_name: {
      placeholder: 'Voornaam',
    },
    customer_last_name: {
      placeholder: 'Achternaam',
    },
    customer_email: {
      placeholder: 'E-mailadres',
    },
    customer_phone_number: {
      placeholder: 'Telefoonnummer',
    },
  },
  validation: {
    customer_first_name: {
      required: 'Voer je voornaam in',
    },
    customer_last_name: {
      required: 'Voer je achternaam in',
    },
    customer_email: {
      required: 'Voer je e-mailadres in',
    },
    customer_phone_number: {
      required: 'Voer je telefoonnummer in',
    },
  },
};
